import { render, staticRenderFns } from "./Rappi.vue?vue&type=template&id=0712b4a0"
import script from "./Rappi.vue?vue&type=script&lang=js"
export * from "./Rappi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports